<template>
  <div class="aboutus-hero">
    <img :src="carousel.image" :alt="carousel.alt" />
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
// 从 i18n 获取轮播图配置
const carousel = {
  image: t('aboutUs.carousel.image'),
  alt: t('aboutUs.carousel.alt')
}
</script>

<style scoped>
.aboutus-hero {
  /* margin-top: var(--header-height, 80px); */
  width: 100%;
}
.aboutus-hero img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
</style>